// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1nUBT","picture":"picture__2_xWS","title":"title__1t8k7","details":"details__1_iI2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/styles.scss
// module id = 245
// module chunks = 0